export const getFulfillmentTypeName = (
  fulfillmentType?:
    | "direct"
    | "courier"
    | "haulier"
    | "collection"
    | "ups"
    | "apc"
    | "dx"
    | "dxBasic"
    | "dxDropOff"
    | "parcelforce"
    | "sellarDistribution",
): string => {
  switch (fulfillmentType) {
    case "direct":
      return "Direct";
    case "courier":
      return "Courier";
    case "collection":
      return "Collection";
    case "haulier":
      return "Pallet";
    case "ups":
      return "UPS";
    case "apc":
      return "APC";
    case "dx":
      return "DX";
    case "dxBasic":
      return "DX Basic";
    case "dxDropOff":
      return "DX Drop Off";
    case "parcelforce":
      return "Parcelforce";
    case "sellarDistribution":
      return "Sellar Distribution";
    default:
      return "Unknown";
  }
};
